<template>
  <div
    v-show="visible"
    class="m-matchs-panel"
    :style="{
      top: `${top}px`
    }"
    @click="handleClose"
  >
    <div
      v-block-loading:fetchData.game="loading"
      class="m-detail-match-list scroll-container"
    >
      <template v-if="loading === false">
        <template v-if="liveMatches.order && liveMatches.order.length">
          <template v-for="(tournamentId) in liveMatches.order">
            <div
              :key="tournamentId"
              class="m-tournament"
            >
              <div class="m-tournament--title-bar">
                <div class="m-tournament--title">
                  <div class="m-text">
                    {{ liveMatches.map[tournamentId].category }} - {{ liveMatches.map[tournamentId].tournament }}
                  </div>
                </div>
              </div>

              <div class="m-event-list">
                <div class="m-event-list--inner">
                  <template v-for="eventId in liveMatches.map[tournamentId].events.order">
                    <MatchItem
                      :key="eventId"
                      :event="liveMatches.map[tournamentId].events.map[eventId]"
                      :current-event-id="event.eventId"
                      @click="handleClose"
                    />
                  </template>
                </div>
              </div>
            </div>
          </template>
        </template>

        <!-- empty data -->
        <NoMatches v-else />
      </template>
    </div>
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import modalHelper from '@ms/utils/scroll-fixed'
import NoMatches from 'wap/components/Empty'
import MatchItem from './MatchItem'

export default {
  name: 'MatchesList',
  components: {
    NoMatches,
    MatchItem
  },
  model: {
    prop: 'visible',
    event: 'close'
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const matchDetailStore = useMatchDetailStore()
    const { event, liveMatches } = storeToRefs(matchDetailStore)

    const { getLiveMatches, subLiveMatches } = matchDetailStore

    return {
      event,
      liveMatches,
      getLiveMatches,
      subLiveMatches
    }
  },
  data() {
    return {
      top: 0,
      loading: true
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.setPositionTop()
      }
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.setPositionTop()
  },
  activated() {
    this.setPositionTop()
  },
  beforeDestroy() {
    this.subLiveMatches({ isSub: false })
    this.$parent.$el.classList.remove('m-matchs-panel-parent')
  },
  methods: {
    // 计算 position top 值
    setPositionTop() {
      this.$nextTick(() => {
        const rect = this.$parent.$el.getBoundingClientRect()
        this.top = rect.height + rect.top
      })
      this.$parent.$el.classList.add('m-matchs-panel-parent')
    },
    handleClose() {
      modalHelper.beforeClose()
      this.$emit('close', false)
    },
    handleSelect(sport) {
      this.$emit('select', sport)
    },
    async fetchData() {
      this.loading = true
      try {
        await this.getLiveMatches()
        this.subLiveMatches()
        this.setPositionTop()
        this.loading = false
      } catch (error) {
        this.loading = -1
        console.error(error)
      }
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");
@import url("~wap/common/style/mixin.less");

.m-matchs-panel-parent {
  z-index: 1200 !important;
}

.m-matchs-panel {
  position: fixed;
  z-index: 1998;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  background: fade(#000, 70%);
  .layout-fixed-center();

  .m-detail-match-list {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    max-height: 78.8%;
    background: #1b1b1b;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 11%);
    -webkit-overflow-scrolling: auto;
    overflow-y: auto;

    .m-match-item-wrap {
      &.active {
        margin-top: -1px;
        background: #333;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 11%);
      }
    }
  }

  .m-tournament {
    &--title-bar {
      width: 100%;
      height: 24/@rem;
      box-sizing: border-box;
      padding: 0 15/@rem;
      background: #2b2a2a;
      line-height: 24/@rem;
    }

    .m-tournament--title {
      color: #999;
      font-size: 10/@rem;

      .m-text {
        width: 90%;
        .ellipsis();
      }
    }
  }
}

// 默认显示滚动条
.m-matchs-panel .m-detail-match-list::-webkit-scrollbar {
  width: 2px;
  height: 13px;
  border-radius: 2px;
}

.m-matchs-panel .m-detail-match-list::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background: #999;
}
</style>

<style lang="scss" scoped>
[data-mode="light"] .m-detail-match-list {
  background: #fff;

  .m-tournament--title-bar {
    background: linear-gradient(180deg, #fff 0%,#f7f7f7 100%);
  }

  .m-tournament--title {
    color: #666;
  }

  .m-match-item-wrap.active {
    background: #f1f1f1;
    box-shadow: none;

    ::v-deep .m-match-item {
      border-bottom: none;
    }
  }

  .m-match-item-wrap:last-child ::v-deep .m-match-item {
    border-bottom: none;
  }

  ::v-deep .m-match-item {
    border-bottom: 1px solid #ececec;

    .m-teams {
      color: #000;
    }

    .m-match-item--footer  .m-time {
      color: #ff7d1e;
    }
  }
}
</style>
